<template>
  <div class="dialog-table-panel">
    <div class="dialog-table-panel">
      <table class="table table-striped table-hover main-table">
        <thead>
          <tr>
            <th class="text-center w80">{{ lang.S0139 }}</th>
            <th class="text-center w20">
              <span class="table-header" role="button" @click="toggleAll">{{
                lang.S0172
              }}</span>
            </th>
          </tr>
        </thead>
        <tbody class="main-table-scrollbar client-policies-table">
          <tr v-for="setting in settings" :key="setting.ReportingFeatureGuid">
            <td class="td-cb-policies w80">
              <span
                class="table-header"
                role="button"
                @click="setting.Permitted = !setting.Permitted"
                >{{ setting.ReportingFeatureName }}</span
              >
            </td>
            <td class="td-cb-policies w20">
              <a
                role="button"
                class="btn btn-default btn-cb-policies2"
                @click="
                  (setting.Permitted = !setting.Permitted), $forceUpdate()
                "
              >
                <i
                  class="material-icons md-24 text-primary"
                  v-if="setting.Permitted"
                  >check_box</i
                >
                <i class="material-icons md-24 text-primary" v-else
                  >check_box_outline_blank</i
                >
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import policiesMixin from "../../mixins/policiesmixin";
import "../../styles/usermanagement.css";

export default {
  name: "settingsPoliciesControl",
  data() {
    return {
      settings: [],
    };
  },
  mixins: [policiesMixin],
  props: ["user", "lang"],
  methods: {
    toggleAll() {
      this.togglePermission(this.settings);
    },
    togglePermission(_items) {
      let selected = _.takeWhile(_items, ["Permitted", true]);
      if (selected.length !== _items.length)
        _.forEach(_items, (itm) => {
          itm.Permitted = true;
        });
      else
        _.forEach(_items, (itm) => {
          itm.Permitted = false;
        });
    },
    saveChanges(successCallback, errorCallback) {
      let featureList = [];
      for (let feature of this.settings) {
        if (feature.Permitted) featureList.push(feature.ReportingFeatureGuid);
      }

      this.putItems(
        this,
        this.getServiceUrl(),
        featureList,
        "settingsPolicies",
        successCallback,
        errorCallback
      );
    },
    getServiceUrl() {
      return `api/UserSecurity/${this.user.UserId}/ReportingFeatures`;
    },
    getUnifiedId(_data) {
      _.forEach(_data, (item) => {
        item.id = item.settingId;
      });
      return _data;
    },
    loadPolicies(successCallback, errorCallback) {
      this.settings = [];

      $.ajax({
        method: "GET",
        url: this.getServiceUrl(),
        success: (data) => {
          this.settings = this.getUnifiedId(data);
          successCallback();
        },
        error: () => {
          console.error(
            "Data access failed in settingsPoliciesControl.loadPolicies()"
          );
          errorCallback();
        },
      });
    },
  },
};
</script>

<style scoped>
tbody {
  min-height: 200px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// SettingsPoliciesControl.vue?60806bb1